export const linkHandler = (link, linkTag, e, onClickHandler, contentBlock) => {
  if (onClickHandler) {
    onClickHandler(contentBlock);
  }
  if (link) {
    let compiledLink = link;
    const hashIndex = link.indexOf('#');
    const slashSlashIndex = link.indexOf('//');

    if (hashIndex > -1 && slashSlashIndex < 0 && linkTag) {
      compiledLink = linkTag + link;
    } else if (linkTag) {
      compiledLink = link + linkTag;
    }
    if (e && (e.ctrlKey || e.metaKey)) {
      window.open(compiledLink, '_blank');
    } else {
      window.location = compiledLink;
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/urlUtils.js